"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=message.model.js.map